import React from 'react'
import useDisclosure from '../../hooks/useDisclosure'

const Disclosure = ({ children, defaultOpen, ...props }) => {
  const { isOpen, onToggle } = useDisclosure({ open: defaultOpen })
  return <div {...props}>{children({ isOpen, onToggle })}</div>
}

export default Disclosure
